export const prettifyOrderId = (orderId: string): string => {
  return orderId.split('-')[0] || '';
};
